import { z } from 'zod';

/**
 * Flow role detection — shared between Playhouse (mini-apps/playhouse/api.ts,
 * via mini-apps/_shared/flow/role.ts) and Command Center's role-based default
 * filters (src/services/flow/identity.ts).
 *
 * Matching rules lifted verbatim from the pre-existing Playhouse `detectRole`
 * (division/user_role_name/title heuristics on the salesforce_user mirror).
 * The one behavior change from that original: this returns `null` instead of
 * defaulting to 'gtme' when nothing matches. That null case is load-bearing —
 * admins and anyone without a clear signal must NOT be scoped to a "my book"
 * default filter (Command Center's role-default-filters spec). Playhouse's
 * call site restores the old default explicitly via `?? 'gtme'`.
 */

export const FlowRoleSchema = z.enum(['gtme', 'gs', 'claydr']);
export type FlowRole = z.infer<typeof FlowRoleSchema>;

export function detectFlowRole(
  division: string | null,
  userRoleName: string | null,
  title: string | null,
): FlowRole | null {
  const d = (division ?? '').toLowerCase();
  const r = (userRoleName ?? '').toLowerCase();
  const t = (title ?? '').toLowerCase();
  if (d.includes('growth') || r.includes('growth strategist') || t.includes('growth strategist')) return 'gs';
  if (
    d.includes('claydr') || d.includes('clay dr') ||
    t.includes('claydr') || t.includes('clay dr') ||
    r === 'sales development representative'
  ) return 'claydr';
  return null;
}
